export default __webpack_public_path__ + "static/new-insight-light-mode-655b8c321ef0d4a769e7849c4f705652.png";